import { IQueryClassDependency } from '@kurtosys/types/dependencies/IQueryClassDependency.js';
import { ITransformClassDependency } from '@kurtosys/types/dependencies/ITransformClassDependency.js';
import { IExecutionOptions } from '@kurtosys/types/query/IExecutionOptions.js';
import { IQueryOptions } from '@kurtosys/types/query/IQueryOptions.js';
import { IQueryOptionsGlobalSearchContent } from '@kurtosys/types/query/options/IQueryOptionsGlobalSearchContent.js';
import { GlobalSearchArticle } from '@kurtosys/types/wordpressGlobalSearch/GlobalSearchArticle.js';

import { helpers } from '../../common/index.js';
import { queryHelper } from '../queryUtils/index.js';

import { BaseCollectionQuery } from './base/BaseCollectionQuery.js';

export class WordpressGlobalSearchContentQuery extends BaseCollectionQuery<IQueryOptionsGlobalSearchContent> {
	constructor(
		public dependencies: IQueryClassDependency & ITransformClassDependency,
		public queryOptions: IQueryOptions,
		public translationHelper?: helpers.TranslationHelper,
	) {
		super(dependencies, queryOptions, translationHelper);
	}

	getOptions(): IQueryOptionsGlobalSearchContent {
		const { code, key, collectionItemConditional, sort, options = {} } = this.queryOptions;
		return {
			code,
			key,
			collectionItemConditional,
			sort,
			...(options.wordpressGlobalSearch || {}),
		};
	}
	getRawValue<T = any>(executionOptions: IExecutionOptions): T {
		const { sort } = this.options;

		let posts = this.getPosts(executionOptions) as any;
		if (sort) {
			posts = this.applySort(posts, sort, undefined, executionOptions.inputs);
		}
		return posts && posts.map((post) => this.getPost(executionOptions, post));
	}
	getPosts(executionOptions: IExecutionOptions): GlobalSearchArticle[] {
		const conditionalHelper = new helpers.ConditionalHelper(
			{ queryClass: this.dependencies.queryClass },
			{ conditions: [] },
			this.translationHelper,
		);
		const { collectionItemConditional = { conditions: [] } } = this.options;

		const context = queryHelper.getContext(executionOptions, this.queryOptions);
		const { articles } = context.wordpressGlobalSearch;
		if (articles) {
			const collectionItems = articles.filter((item) => {
				return conditionalHelper.matches(item, collectionItemConditional, executionOptions);
			});
			return collectionItems;
		}

		return;
	}
	getPost<T>(executionOptions: IExecutionOptions, post: GlobalSearchArticle): T {
		const { code, key } = this.options;

		return this.getPostValue(executionOptions, post, code, key) as any;
	}
	getPostValue<T>(
		executionOptions: IExecutionOptions,
		post: GlobalSearchArticle,
		code: string = null,
		key: string = null,
	): T {
		if (post) {
			if (code && key) {
				const postMeta = post[code];
				const postMetaByKey = postMeta[key];
				if (postMetaByKey) {
					return postMetaByKey;
				}
			}
			if (code) {
				return post[code];
			}
		}
		return;
	}
}
